// extracted by mini-css-extract-plugin
module.exports = {"fieldContainer":"SuspendUserModal__fieldContainer","modal":"SuspendUserModal__modal","suspensionButtons":"SuspendUserModal__suspensionButtons"};